import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ContactItemDto, CustomerItemDto } from '@/api/generated';
import { SelectCustomerOrContactForProcessProps } from '@/views/processesCreate/components/customerOrContact/SelectCustomerOrContactForProcess.comp.tsx';
import { CreateProcessFormModel } from '@/views/processesCreate/model/CreateProcessForm.model.ts';
import { processesCreateUtil } from '@/views/processesCreate/utils/processesCreate.util.ts';

type Props = {
  Component: React.FC<SelectCustomerOrContactForProcessProps>;
};

export const SelectCustomerOrContactForProcessEditWrapper: React.FC<Props> = ({ Component }) => {
  const formMethods = useFormContext<CreateProcessFormModel>();

  const handleSelectCustomer = (customer: CustomerItemDto) =>
    processesCreateUtil.selectCustomer(formMethods.setValue, customer);

  const handleSelectContact = (contact: ContactItemDto) =>
    processesCreateUtil.selectContact(formMethods.setValue, contact);

  const customer = formMethods.watch('customer') ?? null;
  const contact = formMethods.watch('contact') ?? null;

  return (
    <Component
      contact={contact}
      customer={customer}
      customerTableKey="addProcessCustomer"
      onSelectContact={handleSelectContact}
      onSelectCustomer={handleSelectCustomer}
      urlStateEnabled={false}
    />
  );
};
